<core-helpers-navigation-vertical-tabs-workflow 
    [menu]="dashboardMenu" 
    [fullMatch]="match"
    (menuClick)="onMenuClick($event)"
></core-helpers-navigation-vertical-tabs-workflow>
